import { Parcel, ParcelFilter } from './../webApi/DataModels'
import webApi from '@/webApi'
import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import { map, find } from 'lodash'
import constants from '@/constants'
class PudoState {
  public expiredParcels:Parcel[] = []
  public expiryHistoryParcels:Parcel[] = []
  public currentExpiryOptions:any[] = []
  public selectedExpiredParcelIDs:number[] = []
  public selectedCountry:number = -1
  public selectedCustomer:number = -1
}
const mutations = <MutationTree<PudoState>>{
  setSelectedExpiredParcels (state:PudoState, expiredParcelIDs:number[]):void {
    state.selectedExpiredParcelIDs = expiredParcelIDs
  },
  setCurrentExpiryOptions (state:PudoState, options:any[]):void {
    state.currentExpiryOptions = options
  },
  setSelectedCountry (state:PudoState, countryID:number):void {
    state.selectedCountry = countryID
  },
  setSelectedCustomer (state:PudoState, customerID:number):void {
    state.selectedCustomer = customerID
  },
  clearExpiredParcels (state:PudoState):void {
    state.expiredParcels = []
  },
  setExpiredParcels (state: PudoState, expiredParcels:any[]):void {
    state.expiredParcels = map(expiredParcels, (element) => {
      for (const key in constants.REFERENCE_TYPE_NAME) {
        if (Object.prototype.hasOwnProperty.call(constants.REFERENCE_TYPE_ID, key)) {
          const reference = constants.REFERENCE_TYPE_ID[key]
          const foundReference:any = find(element.Parcel.Reference, { Reference_Type_ID: reference })
          if (foundReference) {
            element.Parcel[key] = foundReference.Reference_Text
          }
        }
      }
      element.Parcel.Customer_Name = element.Parcel.Customer.Customer_Name
      element.Parcel.Country_Name = element.Parcel.Country.Country_Name

      element.Parcel.Delivery_Address_Name = element.Parcel.Delivery_Address.Name_1
      element.Parcel.Delivery_Address_Street = element.Parcel.Delivery_Address.Street_1
      element.Parcel.Delivery_Address_Postal_Code = element.Parcel.Delivery_Address.Postal_Code
      element.Parcel.Delivery_Address_City = element.Parcel.Delivery_Address.City

      return {
        Latest_Expiry_Date: element.Latest_Expiry_Date,
        ...element.Parcel
      }
    })
  },
  setExpiryHistory (state: PudoState, parcels:any[]):void {
    state.expiryHistoryParcels = map(parcels, (element) => {
      for (const key in constants.REFERENCE_TYPE_NAME) {
        if (Object.prototype.hasOwnProperty.call(constants.REFERENCE_TYPE_ID, key)) {
          const reference = constants.REFERENCE_TYPE_ID[key]
          const foundReference:any = find(element.Parcel.Reference, { Reference_Type_ID: reference })
          if (foundReference) {
            element.Parcel[key] = foundReference.Reference_Text
          }
        }
      }
      element.Parcel.Customer_Name = element.Parcel.Customer.Customer_Name
      element.Parcel.Country_Name = element.Parcel.Country.Country_Name

      return {
        New_Expiry_Date: element.New_Expiry_Date,
        Latest_Expiry_Date: element.Latest_Expiry_Date,
        Expiry_Action: element.PUDO_Expiry_Option.Description,
        ...element.Parcel
      }
    })
  },
  reset (state:PudoState) {
    state.selectedCountry = -1
    state.selectedCustomer = -1
    state.expiredParcels = []
    state.expiryHistoryParcels = []
    state.currentExpiryOptions = []
    state.selectedExpiredParcelIDs = []
  }
}

const actions = <ActionTree<PudoState, any>>{
  loadExpiredParcels (store: ActionContext<PudoState, any>, parcelFilter:ParcelFilter): Promise<any> {
    store.commit('clearExpiredParcels')
    return webApi.pudo.get_Expired_Parcels(parcelFilter).then((response) => {
      var result = response.data
      store.commit('setExpiredParcels', result)
      return Promise.resolve('success')
    }).catch((error) => {
      window.bus.$emit('openErrorModal', error.data.ExceptionMessage)
      return Promise.reject(error)
    })
  },
  loadExpiryHistory (store: ActionContext<PudoState, any>, parcelFilter:ParcelFilter): Promise<any> {
    return webApi.pudo.get_PUDO_Expiry_History(parcelFilter).then((response) => {
      var result = response.data
      store.commit('setExpiryHistory', result)
      return Promise.resolve('success')
    }).catch((error) => {
      window.bus.$emit('openErrorModal', error.data.ExceptionMessage)
      return Promise.reject(error)
    })
  },
  loadExpiryOptions (store: ActionContext<PudoState, any>, parcelFilter:ParcelFilter): Promise<any> {
    return webApi.pudo.get_Expiry_Options(parcelFilter).then((response) => {
      var result = response.data
      store.commit('setCurrentExpiryOptions', result)
      return Promise.resolve('success')
    }).catch((error) => {
      window.bus.$emit('openErrorModal', error.data.ExceptionMessage)
      return Promise.reject(error)
    })
  },
  saveExpiryAction (store: ActionContext<PudoState, any>, actionID:number):Promise<any> {
    return webApi.pudo.save_PUDO_Expiry(store.state.selectedExpiredParcelIDs, actionID)
      .then((response) => {
        return Promise.resolve('success')
      }).catch((error) => {
        window.bus.$emit('openErrorModal', error.data.ExceptionMessage)
        return Promise.reject(error)
      })
  },
  reset (store: ActionContext<PudoState, any>):void {
    store.commit('reset')
  }
}
const getters = <GetterTree<PudoState, any>> {

}
export default ({
  namespaced: true,
  state: new PudoState(),
  mutations,
  actions,
  getters
})
